import React, {useEffect, useRef, useState} from "react";
import './navbar.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMobile } from "../../globals/helpers";
import { primaryInput } from "detect-it";


const Navbar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isMobView, setIsMobView] = useState(false);
    const [isSafari, setIsSafari] = useState(null);
    const [isMouse, setIsMouse] = useState(null);

    
    function responsiveResize(){
        let slug = location.pathname;
        let isHome = false;
        if(slug == '/') isHome=true;
        let curWidth = window.innerWidth, curheight = window.innerHeight;
        setIsMobView(isMobile(curWidth, curheight, isHome));
    }

    useEffect(() => {
        let path = location.pathname;
        
    }, [location])

    useEffect(() => {
        responsiveResize();

        if(primaryInput == "mouse"){
            setIsMouse(true)
        }

        let tmpSafariCheck = window.safari !== undefined;
        if(tmpSafariCheck){setIsSafari(true)}

        window.addEventListener('resize', responsiveResize, false);
        return() => {
            window.removeEventListener('resize', responsiveResize)
        }
    }, [])

    const handleNavClick = (endpoint) => {
        navigate(endpoint)
    }

    return (
        <>
            <div className={`navbar_wrapper  ${isMobView ? 'is-mobile' : ''}`}>
                
                <div className="navbar_upper_wrapper">
                    <div className="left_wrap">
                        <div className="logo_wrap"
                            onClick={() => handleNavClick('/')}
                            onMouseEnter={() => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.add("cursor-active")
                                }
                                catch{

                                }
                            }}  
                            onMouseLeave={() => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.remove("cursor-active")
                                }
                                catch{

                                }
                            }} 
                        >
                            <span>DN-PRD</span>
                            {
                                isMouse &&
                                <div className="box-hov-indicator box-xs" onMouseEnter={(e) => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                    }}
                                    onMouseLeave={(e) => {
                                        try{
                                            let test = document.getElementById('cursor-circle');
                                            test.classList.remove("cursor-active")
                                        }
                                        catch{

                                        }
                                    }}> 
                                    <span className="bx-h bx-tl"></span>
                                    <span className="bx-h bx-tr"></span>
                                    <span className="bx-h bx-bl"></span>
                                    <span className="bx-h bx-br"></span>

                                    <span className="bx-v bx-tl"></span>
                                    <span className="bx-v bx-tr"></span>
                                    <span className="bx-v bx-bl"></span>
                                    <span className="bx-v bx-br"></span>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="dead_center_col">

                    </div>
                    <div className="right_wrap">
                        <div className="right_nav_content_wrapper">
                            <div 
                                className="contact_wrap"
                                onClick={() => handleNavClick('/contact')}
                                onMouseEnter={() => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                }}  
                                onMouseLeave={() => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.remove("cursor-active")
                                    }
                                    catch{

                                    }
                                }}  
                            >
                                <span>CONTACT</span>
                                {
                                isMouse &&
                                <div className="box-hov-indicator box-xs" onMouseEnter={(e) => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                    }}
                                    onMouseLeave={(e) => {
                                        try{
                                            let test = document.getElementById('cursor-circle');
                                            test.classList.remove("cursor-active")
                                        }
                                        catch{

                                        }
                                    }}> 
                                    <span className="bx-h bx-tl"></span>
                                    <span className="bx-h bx-tr"></span>
                                    <span className="bx-h bx-bl"></span>
                                    <span className="bx-h bx-br"></span>

                                    <span className="bx-v bx-tl"></span>
                                    <span className="bx-v bx-tr"></span>
                                    <span className="bx-v bx-bl"></span>
                                    <span className="bx-v bx-br"></span>
                                </div>
                            }
                            </div>
                            <div className="archive_wrap" 
                                onClick={() => handleNavClick('/archive')}
                                onMouseEnter={() => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                }}  
                                onMouseLeave={() => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.remove("cursor-active")
                                    }
                                    catch{

                                    }
                                }}
                                >
                                <span>ARCHIVE</span>
                                {
                                isMouse &&
                                <div className="box-hov-indicator box-xs" onMouseEnter={(e) => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                    }}
                                    onMouseLeave={(e) => {
                                        try{
                                            let test = document.getElementById('cursor-circle');
                                            test.classList.remove("cursor-active")
                                        }
                                        catch{

                                        }
                                    }}> 
                                    <span className="bx-h bx-tl"></span>
                                    <span className="bx-h bx-tr"></span>
                                    <span className="bx-h bx-bl"></span>
                                    <span className="bx-h bx-br"></span>

                                    <span className="bx-v bx-tl"></span>
                                    <span className="bx-v bx-tr"></span>
                                    <span className="bx-v bx-bl"></span>
                                    <span className="bx-v bx-br"></span>
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                   
                    {/* <div className="contact_wrap" onClick={() => handleNavClick('/contact')}>
                        <span>CONTACT</span>
                    </div>
                    <div className="logo_wrap" onClick={() => handleNavClick('/')}>
                        <span>DN-PRD</span>
                    </div>
                    <div className="archive_wrap" onClick={() => handleNavClick('/archive')}>
                        <span>ARCHIVE</span>
                    </div> */}
                </div>
                {
                    !isMobView &&
                    <div className="navbar_lower_wrapper">
                        <div className="left_wrap">
                            
                            {/* <div className="copy_wrap">
                                <span>©2024</span>
                            </div> */}
                        </div>
                        <div className="right_wrap">
                        </div>
                    </div>
                }
            </div>
            { 
                isSafari !== null && !isSafari &&
                <div className="navbar_blur_wrapper" />
            }
        </>
    )
}

export default Navbar;